import { __decorate } from 'tslib';
import Noty from 'noty';
import { ɵɵdefineInjectable, Injectable, Component, NgModule } from '@angular/core';

let NgxNotyService = class NgxNotyService {
    constructor() {
    }
    show(options) {
        const noty = new Noty(options);
        noty.show();
    }
};
NgxNotyService.ɵprov = ɵɵdefineInjectable({ factory: function NgxNotyService_Factory() { return new NgxNotyService(); }, token: NgxNotyService, providedIn: "root" });
NgxNotyService = __decorate([
    Injectable({
        providedIn: 'root'
    })
], NgxNotyService);

let NgxNotyComponent = class NgxNotyComponent {
    constructor() { }
    ngOnInit() {
    }
};
NgxNotyComponent = __decorate([
    Component({
        selector: 'lib-ngx-noty',
        template: `
    <p>
      ngx-noty works!
    </p>
  `
    })
], NgxNotyComponent);

let NgxNotyModule = class NgxNotyModule {
};
NgxNotyModule = __decorate([
    NgModule({
        declarations: [NgxNotyComponent],
        imports: [],
        exports: [NgxNotyComponent]
    })
], NgxNotyModule);

/*
 * Public API Surface of ngx-noty
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NgxNotyComponent, NgxNotyModule, NgxNotyService };
//# sourceMappingURL=ngx-noty.js.map
